<template>
  <div class="editar-version screen page formActions b-soft">
    <div class="grid">
      <formVersion 
      v-bind:prop_cotizacion="cotizacion" 
      v-bind:prop_version="version" 
      v-on:actionChange="onActionChange" />
      <GetFooter />
    </div>
  </div>
</template>

<script>
import formVersion from '@/components/form-version.vue'
import GetFooter from '@/components/footer.vue'
import { db, auth } from '@/firebase'
export default {
  name: 'app',
  components: {
    formVersion,
    GetFooter
  },
  data() {
    return {
      cotizacion: {},
      version: {},
      isEditing: false
    }
  },
  created() {
    if(this.$route.params.id){
      //obtener cotizacion
      db.collection('cotizaciones').doc(this.$route.params.id)
      .get()
      .then(doc => {
        if (doc.exists) {
          //ajustar valores a cotizacion
          this.cotizacion = doc.data()
          this.$set(this.cotizacion, 'id', doc.id)
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      })
    }
    if(this.$route.params.version){
      //obtener cotizacion
      this.$bind('version', db.collection('cotizaciones').doc(this.$route.params.id).collection('versiones').doc(this.$route.params.version)).then(version => {
        this.version === 'version'
        // version are ready to be used
        // if it contained any reference to other document or collection, the
        // promise will wait for those references to be fetched as well

        // you can unbind a property anytime you want
        // this will be done automatically when the component is destroyed
        this.$unbind('version', false)
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    if(this.isEditing === true){
      const answer = window.confirm('¿Estás Seguro? Se perderá la información que se haya modificado')
      if(answer){
        next()
      }
    }else{
      next()
    }
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav)
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("beforeunload", this.preventNav);
    })
  },
  methods: {
    onActionChange(getactionChange){
      this.isEditing = getactionChange
    },
    preventNav(event) {
      if (!this.isEditing) return
      event.preventDefault()
    },
  },
}
</script>